import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { PageCard, PageLayout } from '@/components/ui/page'

import { itemCategoryDetail } from '@/features/item/api'
import { ItemCategoryUpdateForm } from '@/features/item/components/item-category-form'

export const Route = createFileRoute('/_app/inventory/category/$id/edit')({
	loader: async ({ context, params }) => {
		const { qc } = context
		const { id } = params

		await qc.ensureQueryData(itemCategoryDetail.qry({ id }))
	},
	component: RouteComponent,
})

function RouteComponent() {
	const { id } = Route.useParams()
	const { category } = useSuspenseQuery(itemCategoryDetail.qry({ id })).data

	return (
		<PageLayout.Root>
			<PageLayout.Header
				breadcrumbs={[
					['/inventory', 'Inventory'],
					['/inventory/category', 'Kategori'],
					['/inventory/category/$id', category.name],
					[Route.fullPath, 'Edit'],
				]}
			/>
			<PageCard.Root>
				<PageCard.Header title="Buat data master" />
				<ItemCategoryUpdateForm />
			</PageCard.Root>
		</PageLayout.Root>
	)
}
